import React from 'react';

import Button from '@material-ui/core/Button';

import LoadingAnimation from '../Layout/LoadingAnimations/loading'

import './index.scss';

export default function SpotlioButton(props){
    const disableButton = () => {
        if (props.callBack) props.callBack()
        if (props.onClick) props.onClick();
    }

    const spinnerSize = props.spinnerSize || 24;

    let content = props.children;

    if (props.loading) {
        if (props.loadingMessage) {
            content = props.loadingMessage;
        } else {
            content = <LoadingAnimation size={spinnerSize}/>
        }
    }

    return(
        <Button className={"animatedButton " + props.className + (props.disabled ? " disabled" : "")} onClick={props.loading ? null : () => disableButton()} disabled={props.disabled || props.loading}>
            { content }
        </Button>
    )
}
